import { Link } from 'react-router-dom';
import { categoryData } from '@/mocks/categories';

export default function CategoryNav() {
  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-[var(--font-heading)]">
            内容分类导航
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            八大领域全覆盖，总有一个分类适合您
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
          {categoryData.map((cat) => {
            const colorClass =
              cat.color === 'primary'
                ? 'bg-primary-100/70 text-primary-700 group-hover:bg-primary-500 group-hover:text-white'
                : cat.color === 'accent'
                  ? 'bg-accent-100/80 text-accent-700 group-hover:bg-accent-500 group-hover:text-white'
                  : 'bg-secondary-100/80 text-secondary-700 group-hover:bg-secondary-500 group-hover:text-white';

            return (
              <Link
                key={cat.id}
                to={`/category/${cat.id}`}
                className="group block p-5 md:p-6 bg-white rounded-xl border border-background-200/70 hover:border-primary-200 transition-all duration-300 no-underline"
              >
                <div
                  className={`w-12 h-12 md:w-14 md:h-14 rounded-xl flex items-center justify-center mb-4 transition-all duration-300 ${colorClass}`}
                >
                  <i className={`${cat.icon} text-xl md:text-2xl`}></i>
                </div>
                <h3 className="text-base md:text-lg font-semibold text-foreground-900 mb-1">
                  {cat.name}
                </h3>
                <p className="text-xs md:text-sm text-foreground-500 line-clamp-2 leading-relaxed">
                  {cat.description}
                </p>
                <div className="mt-3 flex items-center gap-1 text-xs text-foreground-400">
                  <span>{cat.articleCount}篇文章</span>
                  <i className="ri-arrow-right-line text-xs transition-transform duration-300 group-hover:translate-x-1"></i>
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}